import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8zOWUzeGEwIHsKICBvdmVyZmxvdzogaGlkZGVuOwp9';
export var content = '_39e3xa0';